"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const base_ui_components_atoms_typography_1 = require("@motorata/base-ui.components.atoms.typography");
function TextHTML({ type = "primary", content }) {
    return react_1.default.createElement(Wrapper, { type: type, dangerouslySetInnerHTML: { __html: content } });
}
exports.default = TextHTML;
const Wrapper = styled_components_1.default.div `
  * {
    overflow-wrap: break-word;
  }

  ul, ol {
    li {
      font-size: ${({ theme }) => theme.font.L};
    }
  }

  h1 {
    ${base_ui_components_atoms_typography_1.h1Styles};
    margin-top: ${({ theme }) => theme.space.L};
  }

  h2 {
    ${base_ui_components_atoms_typography_1.h2Styles};
    margin-top: ${({ theme }) => theme.space.M};
  }

  h3 {
    ${base_ui_components_atoms_typography_1.h3Styles};
    margin-top: ${({ theme }) => theme.space.S};
  }

  p {
    ${base_ui_components_atoms_typography_1.pStyles};
  }

  table {
    margin: ${({ theme }) => theme.space.S} 0;

    th,
    td {
      padding: 5px 10px;
      border: 1px solid rgba(0, 0, 0, 0.1);
    }
  }
  
  ${({ type }) => type === "secondary" && (0, styled_components_1.css) `
    ul, ol {
      li {
        font-size: ${({ theme }) => theme.font.S};
      }
    }

    h1 {
      font-size: ${({ theme }) => theme.font.L};
      margin-top: ${({ theme }) => theme.space.S};
      margin-bottom: ${({ theme }) => theme.space.S};
    }

    h2 {
      font-size: ${({ theme }) => theme.font.M};
      margin-top: ${({ theme }) => theme.space.XS};
      margin-bottom: ${({ theme }) => theme.space.XS};
    }

    h3 {
      font-size: ${({ theme }) => theme.font.S};
      margin-top: ${({ theme }) => theme.space.XXS};
      margin-bottom: ${({ theme }) => theme.space.XXS};
    }

    p {
      font-size: ${({ theme }) => theme.font.S};
    }
  `}
`;
//# sourceMappingURL=TextHTML.js.map